import React from "react";
import { decodeHtml } from "../../../assests/extention/commonfunction";

export default function CustomeCategoryandSubcategory({ posts, showcate = false }) {
  const hasIndustry = !!posts?.industry_title;
  const hasCategory = !!posts?.category_title;
  const hasSubcategory = !!posts?.sub_category_title;

  if (!hasIndustry && !hasCategory && !hasSubcategory) return null;

  const headerParts = [];
  if (hasIndustry) headerParts.push("Industry");
  if (hasCategory) headerParts.push("Category");
  
  let headerText = "";
  if (headerParts.length > 0) {
    headerText = headerParts.join(", ");
    if (hasSubcategory) {
       headerText += " & Subcategory";
    }
  } else if (hasSubcategory) {
    headerText = "Subcategory";
  }

  return (
    <div className="lang-sec price-duration align-items-start flex-column">
      <h6>{headerText}</h6>
      {hasIndustry && <p>Industry : {decodeHtml(posts?.industry_title)}</p>}
      {hasCategory && <p>{showcate == true ? '' : 'Category : '} {decodeHtml(posts?.category_title)}</p>}
      {hasSubcategory && <p>Subcategory : {decodeHtml(posts?.sub_category_title)}</p>}
    </div>
  );
}
